import { statsRepository } from "../storage/storage";
import NotImplemented from "../exceptions/not-implemented";

class BaseStatsService {
    async getBoxScore() {
        throw NotImplemented();
    }

    async getByGameId(gameId) {
        return statsRepository.where("gameId").equals(gameId).toArray();
    }

    async getByPlayerId(playerId) {
        return statsRepository.where("playerId").equals(playerId).toArray();
    }

    async getByTeamId(teamId) {
        return statsRepository.where("teamId").equals(teamId).toArray();
    }
}

export default BaseStatsService;
